import { useBlockPanelPropsContext } from "../../lib/panel/panel-container";
import PanelInlineContent from "../../lib/panel/panel-inline-content";
import { useCallback } from "react";
import { RowBlock, RowLayout } from "./types";
import { RowLayoutPresets } from "./index";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@babackapp/ui/components/dropdown-menu";
import { getEditorBlockConfig } from "../index";

export function EmailPanelLayout() {
	const blockProps = useBlockPanelPropsContext();
	const { formAPI } = blockProps;
	const block = blockProps.block as RowBlock;

	const layout = block.properties?.layout ?? "6-6";
	const currentPreset = RowLayoutPresets[layout];

	const handleLayoutChange = useCallback((newLayout: RowLayout) => {
		const newCellSizes = newLayout.split("-").map(size => parseInt(size, 10));
		const currentChildren = block.content?.children || [];

			// Check if block is compatible with the new cell size
		const filteredChildren = currentChildren.map((child, index) => {
			if (!child || index >= newCellSizes.length) {
				return null;
			}

			const cellSize = newCellSizes[index];
			const blockConfig = getEditorBlockConfig(child.type);
			const compatibility = blockConfig?.email?.compatibility?.rowBlock;

			if (compatibility === true) {
				return child;
			}

			if (typeof compatibility === "object") {
				const minSize = compatibility.minSize || 1;
				return cellSize >= minSize ? child : null;
			}

			return null;
		});

		formAPI.updateField(`${formAPI.blockPath}.properties.layout`, newLayout);
		formAPI.updateField(`${formAPI.blockPath}.content.children`, filteredChildren);
	}, [formAPI, block.content?.children]);

	const CurrentPreviewComponent = currentPreset.Preview;

	return (
		<PanelInlineContent title="Disposition">
		<div className="w-full" style={{ maxWidth: 120 }}>
			<DropdownMenu>
				<DropdownMenuTrigger asChild>
					<button
						type="button"
						className="w-full p-2 bg-muted/10 rounded border border-border/50 hover:bg-muted/20 transition-colors cursor-pointer"
					>
						<CurrentPreviewComponent />
					</button>
				</DropdownMenuTrigger>
				<DropdownMenuContent align="start" className="w-56">
					{Object.values(RowLayoutPresets).map((preset) => {
						const PreviewComponent = preset.Preview;
						return (
							<DropdownMenuItem
								key={preset.id}
								onClick={() => handleLayoutChange(preset.id)}
								className="cursor-pointer p-3"
							>
								<PreviewComponent />
							</DropdownMenuItem>
						);
					})}
				</DropdownMenuContent>
			</DropdownMenu>
		</div>
		</PanelInlineContent>
	);
}
